module.exports = __webpack_public_path__ + "static/sports-ccd76cb2928a9ddb6cf158d03dd6c918.jpg";